var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.range),function(i){return _c('div',{key:'empty-box_'+i,staticClass:"box py-4 mb-2 position-relative",attrs:{"data-test-id":'empty-widget__disabled_'+i}},[_c('div',{staticClass:"mask disabled rounded"})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }